export class ViewEnterpriseDashboardBudgetMonthDetail {
	public label: string;

	public referenceBudget: number;
	public actual: number;
	public varianceAmount: number;
	public variancePercent: number;
	public currentBudget: number;
	public currentBudgetPercent: number;

	constructor(viewEnterpriseDashboardBudgetMonthDetail: ViewEnterpriseDashboardBudgetMonthDetail) {
		Object.assign(this, viewEnterpriseDashboardBudgetMonthDetail);
	}
}
